import { Component, Input, OnInit, Output } from '@angular/core';
import { Contract, Lane, Spot, Violation } from 'src/app/core/models';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-mosaic-list',
  templateUrl: './mosaic-list.component.html',
  styleUrls: ['./mosaic-list.component.sass']
})
export class MosaicListComponent implements OnInit {

  @Input() lastData: Violation;
  @Input() violations: Violation[] = [];
  @Input() violationData: Array<{ passId: string; spot: Spot; lane: Lane }> = [];
  @Input() closedPanel = false;
  @Input() contract: Contract;
  @Output() selectedViolation = new EventEmitter<Violation>();

  constructor() { }

  ngOnInit(): void {
  }

  selectViolation(violation: Violation) {
    this.selectedViolation.emit(violation);
    const event = new CustomEvent('selectedViolation', { detail: violation });
    document.dispatchEvent(event);
  }

  getRegulationColor(regulationId: number) {
    const target = this.contract?.ContractConfigColors?.find(a => a.regulationId === regulationId);
    if (target !== undefined) {
      return target.color;
    }
    return '';
  }

}
